import React from 'react';
import { useAddAdminUserComponent } from './useAddAdminUserComponent';
import { Box, Checkbox, FormControlLabel, Grid } from '@mui/material';
import AppFormSelectWrapper from '../../../../components/designe/app-form-select-wrapper';
import { useTranslation } from 'react-i18next';
import AppButton from '../../../../components/designe/app-button/AppButton';
import { useStyles } from './AddAdminUser.styles';
import theme from '../../../../styles/theme';
import { IUser } from '../../../../types/interfaces/user';
import AppFormTextField from '../../../../components/designe/app-form-text-field';

interface IAddPermissionProps {
  adminUser: IUser;
  onClose: () => void;
}

export default function AddAdminUser(props: IAddPermissionProps) {
  const { adminUser, onClose } = props;
  const { t } = useTranslation();
  const { formik, roles, isLoading } = useAddAdminUserComponent(
    onClose,
    adminUser,
  );
  const { classes } = useStyles(theme);

  return (
    <Box>
      <form onSubmit={formik.handleSubmit}>
        <Grid container spacing={1}>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.firstname')}
              fullWidth
              name="firstname"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.lastname')}
              fullWidth
              name="lastname"
              formik={formik}
            />
          </Grid>
          <Grid item sm={12}>
            <AppFormSelectWrapper
              label={t('common.role')}
              name="role"
              options={roles}
              defaultValue={roles?.find((r) => r.id === formik.values.role?.id)}
              formik={formik}></AppFormSelectWrapper>
          </Grid>
          <Grid item sm={12}>
            <AppFormTextField
              label={t('common.email')}
              fullWidth
              name="email"
              formik={formik}
            />
          </Grid>
          {!adminUser?.id && (
            <>
              <Grid item sm={12}>
                <AppFormTextField
                  label={t('common.password')}
                  fullWidth
                  name="password"
                  formik={formik}
                />
              </Grid>
              <Grid item sm={12}>
                <AppFormTextField
                  label={t('common.confirmPassword')}
                  fullWidth
                  name="confirmPassword"
                  formik={formik}
                />
              </Grid>
            </>
          )}
          <Grid item sm={6}>
            <FormControlLabel
              control={
                <Checkbox
                  name="hidden"
                  checked={formik.values.hidden}
                  onChange={(e) =>
                    formik.setFieldValue('hidden', e.target.checked)
                  }></Checkbox>
              }
              label={t('common.hidden')}
            />
          </Grid>
          {adminUser?.id && !adminUser?.active && (
            <Grid item sm={6}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="active"
                    checked={formik.values.active}
                    onChange={(e) =>
                      formik.setFieldValue('active', e.target.checked)
                    }></Checkbox>
                }
                label={t('common.active')}
              />
            </Grid>
          )}
        </Grid>
        <Box className={classes.addAdminUserButtonWrapper}>
          <AppButton variant="outlined" onClick={() => onClose()}>
            {t('common.cancel')}
          </AppButton>
          <AppButton type="submit" loader={isLoading}>
            {adminUser ? t('common.update') : t('common.create')}
          </AppButton>
        </Box>
      </form>
    </Box>
  );
}
